import React from 'react';
import { Modal, Typography, Button } from '@deeptrue-frontend/ui';
import styled from 'styled-components/macro';
import { useFormatMessage } from 'components/IntlProvider';

const Title = styled(Typography)`
  font-weight: 500;
  font-size: 1.25rem;
  color: #253858;
`;

const Content = styled(Typography)`
  white-space: break-spaces;
  padding: 0 1.5rem;
  margin-top: 3.5rem;
  display: inline-block;
`;

const Content2 = styled(Typography)`
  white-space: break-spaces;
  padding: 0 1.5rem;
  margin: 1.5rem 0;
  display: inline-block;
`;

const Header = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  border-bottom: 1px solid #e3e5e8;
  padding: 1.5rem;
`;

const ButtonWrapper = styled.div`
  border-top: 1px solid #e3e5e8;
  padding: 1.5rem 1rem;
  display: flex;
  justify-content: flex-end;
`;

const StyledModal = styled(Modal)`
  max-width: 31.4rem;
  span {
    margin-top: 0.9rem;
    margin-right: 1.8rem;
  }
`;

const StyledButton = styled(Button)`
  border: 1px solid #e3e5e8;
`;

type CompleteDataCollectionModalProps = {
  isVisible: boolean;
  onBackdropClick: any;
  onCloseClick: any;
  onCompleteDataCollection: any;
};

const CompleteDataCollectionModal = (
  props: CompleteDataCollectionModalProps
) => {
  const t = useFormatMessage();
  const {
    isVisible,
    onBackdropClick,
    onCloseClick,
    onCompleteDataCollection,
  } = props;

  return (
    <div>
      <StyledModal
        isVisible={isVisible}
        onBackdropClick={onBackdropClick}
        onCloseClick={onCloseClick}
      >
        <Header>
          <Title>
            {t('dashboard.manual.complete', 'Complete Data Collection')}
          </Title>
        </Header>
        <Content>
          {t(
            'dashboard.manual.complete.modal.text1',
            'By completing the Data Collection, you stop collecting data from the surveys. The survey links already sent will be deactivated. You will also not be able to add more respondents.'
          )}
        </Content>
        <Content2>
          {t(
            'dashboard.manual.complete.modal.text2',
            'The data already collected will still be available in the report.'
          )}
        </Content2>

        <ButtonWrapper>
          <StyledButton variant="secondary" onClick={onCloseClick}>
            {t('dashboard.template.btn.cancel', 'Cancel')}
          </StyledButton>
          <Button
            ml="0.5rem"
            variant="primary"
            onClick={onCompleteDataCollection}
          >
            {t('dashboard.manual.complete', 'Complete Data Collection')}
          </Button>
        </ButtonWrapper>
      </StyledModal>
    </div>
  );
};

export default CompleteDataCollectionModal;
